import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconCaretDown, IconCheck } from '@redteclab/icons'

import { Button } from 'base-ui'

import {
  EXPERIMENTS_TRACK_EVENT_NFC_CTA_CLICK,
  experimentsTrackEvent,
} from '../../../experiments/eventTracking'
import { useGlobalConfigContext } from '../../../global-config'
import { urlResolverGoToNfcAtShopApothekeApp } from '../../../url-handling'
import { NFC_HOW_DOES_IT_WORK_SECTION_ID } from '../NfcLandingPageHowItWorksSection/NfcLandingPageHowItWorksSection'
import { nfcLandingPageTextAccentNowrap } from '../NfcLandingPageTranslationValues'

import { NfcLandingPageHeroTitleBanner } from './NfcLandingPageHeroTitleBanner'
import { NfcLandingPageHeroTitleOnlyText } from './NfcLandingPageHeroTitleOnlyText'

export const NfcLandingPageHeroActions: FC = () => {
  const globalConfig = useGlobalConfigContext()

  const checkIcon = (
    <IconCheck className="size-6 shrink-0 grow-0 text-dark-primary-max" />
  )

  return (
    <div className="flex flex-col gap-6">
      <NfcLandingPageHeroTitleBanner className="tablet:hidden" />
      <NfcLandingPageHeroTitleOnlyText className="hidden tablet:block" />

      <ul className="space-y-2 px-4 text-s tablet:px-0">
        <li className="flex gap-3">
          {checkIcon}
          <div>
            <span>
              <FormattedMessage
                id="nfc.hero.check.discount"
                values={{
                  highlight: nfcLandingPageTextAccentNowrap,
                }}
              />
            </span>
            <span className="mt-1 block text-xs text-dark-primary-strong">
              <FormattedMessage id="nfc.hero.check.discount.subtitle" />
            </span>
          </div>
        </li>
        <li className="flex gap-2">
          {checkIcon}
          <span>
            <FormattedMessage id="nfc.hero.check.delivery.new" />
          </span>
        </li>
        <li className="flex gap-2">
          {checkIcon}
          <span>
            <FormattedMessage id="nfc.hero.check.family" />
          </span>
        </li>
      </ul>

      <Button<'a'>
        className="mx-4 tablet:mx-0 tablet:hidden"
        href={urlResolverGoToNfcAtShopApothekeApp()}
        onClick={() => {
          experimentsTrackEvent(
            globalConfig,
            EXPERIMENTS_TRACK_EVENT_NFC_CTA_CLICK,
          )
        }}
        slots={{ root: 'a' }}
      >
        <FormattedMessage id="nfc.hero.appBtn" />
      </Button>
      <Button<'a'>
        className="hidden self-start tablet:inline-flex"
        color="secondary"
        endIcon={<IconCaretDown />}
        href={`#${NFC_HOW_DOES_IT_WORK_SECTION_ID}`}
        slots={{ root: 'a' }}
        variant="outlined"
      >
        <FormattedMessage id="nfc.hero.btn2" />
      </Button>
    </div>
  )
}
